import { configureStore } from '@reduxjs/toolkit';
import configuratorReducer from './configuratorSlice';

export const store = configureStore({
  reducer: {
    configurator: configuratorReducer,
  },
  // Adding the api middlewxºare enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['configuratorSlice.updateStreamingPlayer'],
        // Ignore these field paths win all actions
        ignoredActionPaths: ['payload.player'],
        // Ignore these paths in the state
        ignoredPaths: ['configurator.streamingPlayer'],
      },
    }),
})
